// Kabuk (AppShell) ve form doldurma dar ekran kuralları — Finar UX P3 (K1/Ö6, TODO-UX-06).
// TEK kaynak: kırılım sorguları + dar ekran kararı. Bileşenler sayı yazmaz, buradan okur.
//
//   > 1024 px  → "wide": 240 px menü ya da elle daraltılmış 60 px ray (tercih kalıcı).
//   768–1024   → "rail": menü kendiliğinden 60 px raya düşer, ☰ açılır menüyü (overlay) açar.
//   < 768 px   → "hidden": ray da yok, yalnız ☰ kalır.
// Elle "Menüyü daralt" tercihi yalnız "wide"da okunur ve yazılır.

/** ≤1024 px: menü raya düşer; form doldurma yan panelleri daraltılmış açılır. */
export const NARROW_QUERY = "(max-width: 1024px)";
/** <768 px: ray da gizlenir (768 dahil değil — 768'de ray görünür). */
export const HIDDEN_RAIL_QUERY = "(max-width: 767.98px)";

export type ShellMode = "wide" | "rail" | "hidden";

export function shellMode(narrow: boolean, hiddenRail: boolean): ShellMode {
  if (hiddenRail) return "hidden";
  return narrow ? "rail" : "wide";
}

/** Kenar menüsü kolonu: wide'da tercih, rail'de daima ray, hidden'da kolon yok. */
export function sidebarColumn(mode: ShellMode, preferCollapsed: boolean): string | null {
  if (mode === "hidden") return null;
  if (mode === "rail" || preferCollapsed) return "var(--layout-sidebar-rail-width)";
  return "var(--layout-sidebar-width)";
}

/** Raydaki menü daraltılmış mı çizilir (ikon + erişilebilir ad). */
export function railCollapsed(mode: ShellMode, preferCollapsed: boolean): boolean {
  return mode === "rail" || (mode === "wide" && preferCollapsed);
}

/** ☰ düğmesi yalnız dar ekranda (rail/hidden) görünür. */
export function showMenuButton(mode: ShellMode): boolean {
  return mode !== "wide";
}

export const SHELL_COPY = {
  openMenu: "Menüyü aç",
  closeMenu: "Menüyü kapat",
  collapseMenu: "Menüyü daralt",
  drawerLabel: "Menü",
} as const;
